export default "__VITE_ASSET__DI4j2g_B__"